import { render, staticRenderFns } from "./MenuOptions.vue?vue&type=template&id=d906fdec&scoped=true&"
import script from "./MenuOptions.vue?vue&type=script&lang=js&"
export * from "./MenuOptions.vue?vue&type=script&lang=js&"
import style0 from "./MenuOptions.vue?vue&type=style&index=0&id=d906fdec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d906fdec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
